export default __webpack_public_path__ + "static/media/icon8.b3ff7b8e.svg";